import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from 'assets/translations/translations.json';

const { language: navigatorLanguage } = navigator;

const translationKeys = Object.keys(translations.resources);

const defaultLanguage = translationKeys.find(item => {
  return item.includes(navigatorLanguage);
});

export const setLanguage = (locale: string) => {
  const localeLanguage = translationKeys.find(item => {
    return item.includes(locale.toUpperCase());
  });
  const language =
    navigatorLanguage.length < 5
      ? defaultLanguage || localeLanguage
      : navigatorLanguage;

  i18next.changeLanguage(language);
};

const initializeTranslations = async () => {
  if (!i18next.isInitialized)
    await i18next.use(initReactI18next).init(translations);
};

export default initializeTranslations;
